import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiCalls } from '../../../../../api/api';
import { TIME_ENTRY_CORRECTIONS } from '../../../../../constants/queryKeys';
import { UseCreateCorrectionReturn, CreateCorrectionData } from '../types';

interface UseCreateCorrectionParams {
    onSuccess?: () => void;
    onClose: () => void;
}

export const useCreateCorrection = ({ onSuccess, onClose }: UseCreateCorrectionParams): UseCreateCorrectionReturn => {
    const [error, setError] = useState<string>('');
    const queryClient = useQueryClient();

    // Create correction with time entry mutation
    const createCorrectionMutation = useMutation({
        mutationFn: async (data: CreateCorrectionData) => {
            const response = await ApiCalls.timeEntryCorrectionsCreateWithTimeEntryCreate(data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [TIME_ENTRY_CORRECTIONS] });
            setError('');
            onSuccess?.();
            onClose();
        },
        onError: (error: any) => {
            setError(error?.response?.data?.message || error?.message || 'Failed to create correction');
        },
    });

    const createCorrection = (data: CreateCorrectionData) => {
        createCorrectionMutation.mutate(data);
    };

    return {
        createCorrection,
        isPending: createCorrectionMutation.isPending,
        error,
        setError,
    };
};
